import { render, staticRenderFns } from "./TeachTable.vue?vue&type=template&id=4c9fef18&scoped=true"
import script from "./TeachTable.vue?vue&type=script&lang=js"
export * from "./TeachTable.vue?vue&type=script&lang=js"
import style0 from "./TeachTable.vue?vue&type=style&index=0&id=4c9fef18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9fef18",
  null
  
)

export default component.exports